

























import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent } from '@vue/composition-api'
import SectionBasic from '../components/SectionBasic.vue'
import BlockListArchiveItems from '@/components/BlockListArchiveItems.vue'
import { SectionCore } from '@/mixins/sectionCore'
import { IDocumentItem } from '@/contracts/DocumentItem'
import CardDocumentList from '@/components/CardLists/CardDocumentList.vue'
import BlockText from '@/components/BlockText.vue'

@Component
class SectionDocuments extends mixins(SectionCore) {
  @Prop() readonly list: ReadonlyArray<IDocumentItem> = []
}

export default defineComponent({
  name: 'SectionDocuments',
  components: {
    CardDocumentList,
    BlockListArchiveItems,
    BlockText,
    SectionBasic,
  },
  props: SectionDocuments.options.props,
  setup() {},
})
